import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSEO } from "@/lib/seo";
import { Reveal } from "@/components/site/Reveal";

const LINKS = [
  { to: "/definition-sculpteur-contemporain", label: "Qu'est-ce qu'un sculpteur contemporain ?" },
  { to: "/courants-et-mouvements", label: "Courants & mouvements" },
  { to: "/materiaux-et-techniques", label: "Matériaux & techniques" },
  { to: "/lexique-sculpture", label: "Lexique de la sculpture" },
  { to: "/guide-achat-direct-artiste", label: "Guide d'achat en direct" },
  { to: "/faq", label: "Questions fréquentes" },
];

export default function NotFound() {
  useSEO(
    "Page introuvable — Sculpteur Français",
    "Cette page n'existe pas ou plus sur sculpteur-francais.com.",
    null,
    { noindex: true, robots: "noindex, follow" }
  );

  return (
    <main data-testid="not-found-page" className="bg-paper pb-24 pt-32 sm:pt-40">
      <div className="mx-auto max-w-3xl px-6 lg:px-10">
        <Reveal y={16}>
          <p className="eyebrow">Erreur 404</p>
        </Reveal>
        <h1 className="mt-6 font-serif text-4xl font-light leading-[1.08] tracking-tight text-ink sm:text-5xl">
          Cette page n'existe pas, ou plus.
        </h1>
        <Reveal delay={0.2}>
          <p className="mt-8 text-lg font-light leading-relaxed text-smoke">
            L'adresse que vous avez suivie ne correspond à aucune page du site.
            Voici les sections principales pour retrouver votre chemin :
          </p>
          <ul className="mt-8 divide-y divide-ink/10 border-y border-ink/10">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`notfound-link-${l.to.replace(/\//g, "")}`}
                  className="group flex items-center justify-between py-4 font-serif text-xl text-ink transition-colors hover:text-bronze"
                >
                  <span className="link-underline">{l.label}</span>
                  <ArrowRight className="h-4 w-4 text-bronze transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </li>
            ))}
          </ul>
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="group mt-10 inline-flex items-center gap-3 bg-ink px-7 py-4 font-mono text-[12px] uppercase tracking-[0.18em] text-paper transition-colors duration-300 hover:bg-bronze"
          >
            Retour à l'accueil
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </main>
  );
}
